// An event sign-up group is one of three kinds. They share the same shape --
// a named group of slots with capacities -- and differ only in how a slot is
// labeled and whether the person signing up has to describe their entry.
export const SIGNUP_TYPES = {
  volunteer: {
    typeLabel: 'Volunteer shifts',
    typeHint: 'Members claim time slots (e.g., Concessions 2-4pm).',
    groupPlaceholder: 'Group name (e.g., Concessions, Grill)',
    addSlotLabel: '+ Add time slot',
    selectPrompt: 'Select a shift',
    capacityTitle: 'Max volunteers',
    summaryLabel: 'Volunteer Spots Filled',
  },
  potluck: {
    typeLabel: 'Potluck dishes',
    typeHint: 'Members claim a food category and say what they are bringing.',
    groupPlaceholder: 'Group name (e.g., Potluck)',
    slotPlaceholder: 'Category (e.g., Appetizers, Desserts)',
    addSlotLabel: '+ Add category',
    selectPrompt: 'Select a category',
    capacityTitle: 'Max dishes',
    summaryLabel: 'Potluck Dishes Claimed',
    detailLabel: 'What are you bringing?',
    detailPlaceholder: 'e.g., Green bean casserole',
  },
  competition: {
    typeLabel: 'Competition entries',
    typeHint: 'Members enter a category and name their entry.',
    groupPlaceholder: 'Group name (e.g., BBQ Competition)',
    slotPlaceholder: 'Category (e.g., Ribs, Brisket)',
    addSlotLabel: '+ Add category',
    selectPrompt: 'Select a category',
    capacityTitle: 'Max entries',
    summaryLabel: 'Competition Entries',
    detailLabel: 'Name your entry',
    detailPlaceholder: "e.g., Smokey's Baby Backs",
  },
}

// Events created before typed groups existed have no `type` -- they are volunteer sheets.
export const getSignupType = (role) => SIGNUP_TYPES[role?.type] || SIGNUP_TYPES.volunteer

export const usesTimeSlots = (role) => (role?.type || 'volunteer') === 'volunteer'

export const requiresDetail = (role) => !usesTimeSlots(role)

// A sheet with only one kind of group can name it on the button; mixed sheets stay generic.
const CTA_LABELS = {
  volunteer: 'Sign Up for Volunteer Shifts',
  potluck: 'Sign Up for the Potluck',
  competition: 'Enter the Competition',
}

export const signupCtaLabel = (roles) => {
  const types = [...new Set((roles || []).map(r => r.type || 'volunteer'))]
  return types.length === 1 ? CTA_LABELS[types[0]] : 'Sign Up for This Event'
}

// Volunteer slots are labeled by their time range, everything else by its label.
export const formatSlotLabel = (role, slot, formatTime) =>
  usesTimeSlots(role)
    ? `${formatTime(slot.startTime)} - ${formatTime(slot.endTime)}`
    : slot.label || 'Untitled'
